export const ADMINISTER_HAM = 'ADMINISTER_HAM';
export const VIEW_HAM = 'VIEW_HAM';
export type HamPermissionKey = typeof ADMINISTER_HAM | typeof VIEW_HAM;
export type HamPermissions = Readonly<Record<HamPermissionKey, boolean>>;
